import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import classnames from 'classnames';
import OrdinaryModel from '../../../pile-sharing-manage/components/sharing-message-modal';
import {
  getParamsFromHash,
  wxInit,
  myInit,
  goToPage,
  getPlatform,
  getChannel,
  jumpPage,
  isNowVersionUpOrMatch,
  defineShareInfoInMiniProgram
} from '../../../../utils/common'
import { Toast as antdToast } from 'antd-mobile'
import { Switch as XPSwitch } from "@xp-design/mobile";
import { CHARGE_CDN, HOME_PILE_SHARE_VERSION, PILE_SHARING_FORM_KEY } from '../../../../utils/constants';
import { trackGdp } from '../../../../utils/gio-report';
import Toast from '../../../../components/toast/index';
import Picker from '../../../../components/Picker'
import FullLoading from '../../../../components/full-loading';
import LoadingPage from '../../../../components/loading-page';
import {
  shareOpenApply,
  queryCurrentUserBasicInfo,
  querySharePileInfo,
  shareStationModifyApply,
  queryShareApplyInfo,
  queryShareNewestApplyInfo
} from '../../../../api/pile-sharing'
import { PriceItem } from './components';
import checkRadio from '../../assets/check-radio.svg';
import checkedRadio from '../../assets/check-radio-black.png';
import step1 from '../../assets/step1.svg';
import step2 from '../../assets/step2.svg';
import step1Select from '../../assets/step1-select.svg';
import step2Select from '../../assets/step2-select.svg';
import more from '../../assets/more.svg'

import './index.less'
// import { ExclamationCircleOutline } from 'antd-mobile-icons';
import { getPileSharingFormFromLocalStorage } from '../../utils';
import { ExclamationCircleOutline } from 'antd-mobile-icons';
import { useAsyncEffect, useRequest } from 'ahooks';
import ResourceBanner from './components/ResourceBanner';
import { getResource } from '../../../../api/resource';

// Cache Keys
const PILE_USER_INFO_KEY = 'pileUserInfo';
const PILE_SHARING_STATION_ID_KEY = 'pileSharingStationId';
const PILE_SHARING_FIRST_KEY = 'pileSharingFirst';
const PILE_SHARING_APPLY_SUBMIT_KEY = 'pileSharingApplySubmit';
const PILE_SHARING_UID_KEY = 'pileSharingUid';
const PILE_SHARING_AGREE_KEY = 'pileSharingAgree';
const HAS_CLICKED_PRICES_SETTING_KEY_PREFIX = 'pile_sharing_';
const HAS_CLICKED_PRICES_SETTING_KEY_SUFFIX = '_hasClickedPricesSetting';
const getHasClickedPricesSettingKey = (uid: string | number) => `${HAS_CLICKED_PRICES_SETTING_KEY_PREFIX}${uid}${HAS_CLICKED_PRICES_SETTING_KEY_SUFFIX}`;
const PILE_SHARING_TAB = 'pileSharingTab';


const DEFAULT_SERVICE_PRICE = 0.8 // 默认的分时价格
// 默认的分时价格：用于未设置或为空时回退
const getDefaultBillingPeriodList = () => [
  { startTime: '00:00', endTime: '24:00',sn: 0, servicePrice: DEFAULT_SERVICE_PRICE },
];

export const floorData: any = {
  value: [
    { value: '8', label: '4F及以上' },
    { value: '7', label: '3F' },
    { value: '6', label: '2F' },
    { value: '5', label: '1F' },
    { value: '4', label: 'B1' },
    { value: '3', label: 'B2' },
    { value: '2', label: 'B3' },
    { value: '1', label: 'B4及以下' },
  ],
}

const HOME_PILE_OWNER_AGREEMENT = 'https://events.xiaopeng.com/0h3jvj.html?ch=00977&ps=event'

enum UserTypeEnum {
  HOST = 1,
  GUEST = 2
}


function PrivateStakeApply({ children }) {
  const { path, url } = useRouteMatch();
  const { origin, pathname } = window.location
  const platFrom = getPlatform()
  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序
  const pileNo: any = getParamsFromHash('pileNo');
  // let pileSharingFormObj: any = {
  //   ...getPileSharingFormFromLocalStorage({}, pileNo)
  // } // 申请表单
  let pileSharingFormObj = JSON.parse(localStorage.getItem(PILE_SHARING_FORM_KEY) as any) || {}
  // 若本地缓存中未设置 billingPeriodList 或为空数组，则使用默认分时价，避免页面无价格显示
  if (!Array.isArray(pileSharingFormObj.billingPeriodList) || pileSharingFormObj.billingPeriodList.length === 0) {
    pileSharingFormObj.billingPeriodList = getDefaultBillingPeriodList();
  }
  if (pileSharingFormObj.fee === undefined) {
    pileSharingFormObj.fee = DEFAULT_SERVICE_PRICE;
  }
  let userInfo = JSON.parse(localStorage.getItem(PILE_USER_INFO_KEY) as any) || {} //用户信息

  // 修改价格信息红点flag
  const hasClickedPricesSetting = !!localStorage.getItem(getHasClickedPricesSettingKey(userInfo?.uid));
  const [showRedPointOfHasClickedPricesSettinge, setShowRedOfHasClickedPricesSettinge] = useState<boolean>(!hasClickedPricesSetting)

  const scheduleRef = useRef<any>(null)
  //  1: 开通申请, 2: 修改申请
  const applyType = useRef(Number(getParamsFromHash('applyType')) || 1);
  const [loading, setLoading] = useState(true)
  const [showPicker, setShowPicker] = useState(false)
  const [isPeriodPriceMeet, setIsPeriodPriceMeet] = useState(true);
  const [isTime, setIsTime] = useState(false)
  const [isCheck, setIsCheck] = useState(false)
  const [pileEnable, setPileEnable] = useState(false)
  const [form, setForm] = useState<any>({
    ...pileSharingFormObj
  })
  const isEdit = (applyType.current === 2);
  const pickerValue = useMemo(() => {
    return { value: form?.floor }
  }, [form?.floor])
  // 版本判断
  const versionMark = isNowVersionUpOrMatch(HOME_PILE_SHARE_VERSION)


  const [step, setStep] = useState<number>(1);

  const ruleList = [
    'userNickName', 'phoneNo', 'address', 'floor', 'parkingSpaceNo', 'billingPeriodList'
  ]

  const setTitle = () => {
    document.title = `共享家充${applyType.current == 1 ? '开通' : '修改'}申请`;
  };

  const floorSelect = () => {
    setShowPicker(true)
  }

  const cancelDateRange = () => {
    setShowPicker(false)
  }

  const confirmDateRange = async (value) => {
    console.log(value, 'floorValue')
    // picker 的bug: 快速滚动后立即点确认按钮，返回的值为 {value: '8'}, 而非 '8'
    // 需要在这里暂时先做个兼容，后续要看picker的问题
    if (value?.value) {
      form.floor = value?.value
    } else {
      form.floor = value
    }
    setForm({ ...form })
    setShowPicker(false)
  }

  const [showPopupModel, setShowPopupModel] = useState(false)

  const nextStepRules = useMemo(() => {
    let arr = ruleList.filter(v => v !== 'userNickName')
    return arr.every(v => {
      if (v === 'billingPeriodList') {
        return form[v] && form[v].length > 0
      }
      return form[v]
    })
  }, [form, pileSharingFormObj])

  const nextStep = () => {
    // if (!nextStepRules) {
    //   return isTime ? '' : Toast.show({ text: '请填完必填字段才可下一步', duration: 1000 })
    // }
    trackGdp('P20067', 'B012', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      'user_channel': getChannel()
    })
    setStep(pre => 2)
  }
  const preStep = () => {
    trackGdp('P20067', 'B003', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      'user_channel': getChannel()
    })
    setStep(pre => 1)
  }

  // 跳转地图
  const toMap = () => {
    // 保存当前表单数据到localStorage
    localStorage.setItem(PILE_SHARING_FORM_KEY, JSON.stringify(form));
    goToPage(`${origin}${pathname}#/apply/map?applyType=${applyType.current}&pileNo=${pileNo}`)
  }
  // 跳转找桩指引
  const toFindGuide = () => {
    // 保存当前表单数据到localStorage
    localStorage.setItem(PILE_SHARING_FORM_KEY, JSON.stringify(form));
    goToPage(`${origin}${pathname}#/apply/findGuide?applyType=${applyType.current}&pileNo=${pileNo}`)
  }

  // 跳转分时价计费
  const toSetPeriodPrices = () => {
    setShowRedOfHasClickedPricesSettinge(false);
    localStorage.setItem(getHasClickedPricesSettingKey(userInfo?.uid), 'true');
    // 保存当前表单数据到localStorage
    localStorage.setItem(PILE_SHARING_FORM_KEY, JSON.stringify(form));
    goToPage(`${origin}${pathname}#/apply/prices?applyType=${applyType.current}&pileNo=${pileNo}&isPeriodPriceMeet=${isPeriodPriceMeet}`)
  }

  // 了解更多
  const toMore = () => {
    window.location.href = 'https://events.xiaopeng.com/3130kn.html?ch=04474&ps=event'
  }



  // 打开协议
  const openProtocol = (e) => {
    e && e.stopPropagation()
    // 上报埋点
    trackGdp('P20067', 'B005', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      'user_channel': getChannel()
    })
    goToPage(HOME_PILE_OWNER_AGREEMENT)
  }

  // 确认协议弹窗
  const protocolModal = () => {
    setShowPopupModel(true)
  }

  const cancelCbk = () => {
    setShowPopupModel(false)
  }

  const confirmCbk = () => {
    setIsCheck(true);
    setShowPopupModel(false);
    submit();
  }

  // 提交申请
  const submit = async () => {
    if (!isCheck && !showPopupModel) {
      return protocolModal()
    }
    if (!ruleList.every(v => form[v])) {
      //  必填都在第一步
      if (step === 2) {
        setStep(1)
      }
      Toast.show({ text: '填写完所有必填字段才可提交', duration: 1000 })
      return
    }
    FullLoading.show({
      text: '加载中'
    });
    delete form.location

    if(step == 1) {
      trackGdp('P20067', 'B011', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type],
        'user_channel': getChannel()
      })
    } else {
       trackGdp('P20067', 'B006', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type],
        'user_channel': getChannel()
      })
    }
    

    try {
      // 兼容：若未设置“申请免审核”字段，则默认置为 0（不开启）
      if (typeof form.isUseApplyAutoAudit === 'undefined') {
        form.isUseApplyAutoAudit = 0
      }
      // 判断找桩指引是否完整：findGuide 统一为数组形式 [{textDesc, picList}]，完整需数组非空且每项有 textDesc 和 picList，且停车位图片列表非空
      let showFindGuide = Array.isArray(form.findGuide) && form.findGuide.length > 0 && form.findGuide.every(v => v.textDesc && v.picList?.length) && form.parkingSpacePicList?.length;
      // 去掉原有字段pileUserInfoObj
      let ajax = {
        ...pileSharingFormObj,
        ...form,
        stationId: applyType.current == 1 ? undefined : localStorage.getItem(PILE_SHARING_STATION_ID_KEY),
        applyType: applyType.current,
        pileNo,
        floor: form.floor ? Number(form.floor) : '',
        fee: form.fee ? Number(form.fee) : '',
        // findGuide 序列化：始终序列化数组，若不完整则传空数组 []
        findGuide: JSON.stringify(showFindGuide ? form.findGuide : []),
        parkingSpacePicList: JSON.stringify(showFindGuide ? form.parkingSpacePicList : [])
      }
      const { data, code, msg } = await (applyType.current == 2 ? shareStationModifyApply(ajax) : shareOpenApply(ajax)).finally(() => {
        FullLoading.hide()
      })
      if ([0, 200].includes(code)) {
        localStorage.removeItem(PILE_SHARING_FORM_KEY)
        localStorage.removeItem(PILE_SHARING_FIRST_KEY)
        localStorage.removeItem(PILE_SHARING_STATION_ID_KEY)
        localStorage?.setItem(PILE_SHARING_APPLY_SUBMIT_KEY, '1')
        window.location.replace(`${origin}${pathname.replace('pile-sharing.html', 'pile-sharing.html')}#/manage?applySubmit=${true}&isEdit=${isEdit}&isPeriodPriceMeet=${isPeriodPriceMeet}`)
      } else {
        return Toast.show({ text: msg, duration: 1000 })
      }
    } catch (error) {
      FullLoading.hide()
    }
  }

  // 跳转到原生预览页
  const goToPreviewPage = (data: any) => {
    trackGdp('P20067', 'B004', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      'user_channel': getChannel()
    })
    if (!data) return
    if (isXPApp) {
      // IOS页面带json参数需要encode 否则无法跳转
      jumpPage(`xiaopeng://xrn/dynamicPage?launchPage=XPMotors_ReactNativePreviewRouter&page=homePileStationDetail&data=${encodeURIComponent(data)}`)
    } else if (isWXApp) {
      wxInit().then(wx => wx.miniProgram.navigateTo({ url: `/pages/preview-router/index?page=homePileStationDetail&data=${data}` }));
    } else if (isMyApp) {
      myInit().then(my => my.navigateTo({ url: `/pages/preview-router/index?page=homePileStationDetail&data=${data}` }))
    } else {
      return Toast.show({ text: '在小鹏APP内才可预览', duration: 1000 })
    }
  }

  // 预览
  const preview = () => {
    try {
      if (!ruleList.every(v => form[v]) && !!pileSharingFormObj?.address) {
        return Toast.show({ text: '填写完所有必填字段才可预览', duration: 1000 })
      }
      let findGuideArr = form.findGuide?.map(v => v?.picList?.[0]) || []
      let imgList = (findGuideArr || []).concat(form.parkingSpacePicList || [])
      let floorDesc;
      if (form.floor < 5) {
        floorDesc = '地下'
      } else if (form.floor == 5) {
        floorDesc = '地面'
      } else {
        floorDesc = '停车楼'
      }

      let data = {
        stationDtl: {
          baseDto: {
            stationName: form.userNickName + '的共享家充',
            longitude: pileSharingFormObj.longitude,
            latitude: pileSharingFormObj.latitude,
            stationAddr: pileSharingFormObj.province + pileSharingFormObj.city + (pileSharingFormObj.district === pileSharingFormObj.city ? '' : pileSharingFormObj.district) + pileSharingFormObj.address,
            positionDesc: form.parkingSpaceNo,
            floor: form.floor,
            floorDesc
          },
          operationDto: {
            operationMode: '4',
            images: imgList, // 全部的图片
            // 基于数组的判断：只有当 findGuide 为数组且每项均有 textDesc 和 picList 时才展示 admission guide
            showAdmissionGuide: Array.isArray(form.findGuide) && form.findGuide.every(v => v.textDesc && v.picList?.length) && form.parkingSpacePicList?.length,
            outsideExplain: form.illustrate
          },
          userInfoDto: {
            roleType: 1, // 1-桩主，2-授权人，3-使用人，4-其他
            contactsName: form.userNickName,
            contactsTel: form.phoneNo,
            contactsWechat: form.weChatNo,
          },
          pileDto: {
            pileNo,
          },
          billingDto: {
            finalTotalPrice: form.fee
          }
        },
        admissionGuide: Array.isArray(form.findGuide) && form.findGuide.length > 0 ? form.findGuide.map((v, i) => ({
          sortNo: i + 1,
          description: v?.textDesc,
          imageUrlList: v?.picList || []
        })) : [] // 找桩指引步骤（已统一为数组）
      }
      goToPreviewPage(JSON.stringify(data))
    } catch (error) {
      console.log('click preview error', error)
    }
  }

  // 同意协议
  // const pileSharingAgree = () => {
  //   trackGdp('P20067', 'B006', {
  //     userId: userInfo?.uid,
  //     userType: UserTypeEnum[userInfo?.type],
  //     'user_channel': getChannel()
  //   })
  //   setModal(false)
  //   setIsCheck(true)
  // }

  const protocolCheck = () => {
    const newCheckState = !isCheck;
    setIsCheck(newCheckState);
  }

  // app push过来的不携带桩编码
  const getPileNo = async () => {
    setLoading(true)

    try {
      const { data = {}, code } = await querySharePileInfo()
      if ([0, 200].includes(code)) {
        localStorage.setItem(PILE_SHARING_STATION_ID_KEY, data.stationId)
        setIsPeriodPriceMeet(!!data.isPeriodPriceMeet);
        setPileEnable(!!data.enable);
        if (!localStorage.getItem(PILE_SHARING_FIRST_KEY)) {
          return getStationInfo(data.stationId, !!data.isPeriodPriceMeet)
        }
        setLoading(false)
      }
    } catch (error) {
      console.error(error)
      // 防止出现错误后，出现bug
      // TODO 以后需要去掉这个逻辑
      localStorage.removeItem(PILE_SHARING_FIRST_KEY)
    }

  }

  const getStationInfo = async (stationId, isPeriodPriceMeet = false) => {
    localStorage.setItem(PILE_SHARING_FIRST_KEY, 'true')

    const { data, code } = await queryShareApplyInfo({
      pileNo
    }).catch(() => {
      setLoading(false)
    })
    if ([0, 200].includes(code)) {
      if (data) {
        setLoading(false)
        delete data.applyStatus
        delete data.applyStatusDesc
        delete data.applyRefuseType
        delete data.applyReqId
        data.floor = data.floor + ''
        data.location = {
          lng: data.longitude,
          lat: data.latitude,
        }
        // 解析 findGuide 字段并兼容历史对象结构，统一为数组 [{textDesc, picList}]
        try {
          const parsedFindGuide = JSON.parse(data.findGuide)
          if (Array.isArray(parsedFindGuide)) {
            data.findGuide = parsedFindGuide
          } else if (parsedFindGuide && (parsedFindGuide.textDesc || parsedFindGuide.picList)) {
            data.findGuide = [parsedFindGuide]
          } else {
            data.findGuide = []
          }
        } catch (e) {
          data.findGuide = []
        }
        // parkingSpacePicList 同样做安全解析
        try {
          data.parkingSpacePicList = JSON.parse(data.parkingSpacePicList) || []
        } catch (e) {
          data.parkingSpacePicList = []
        }
        // 兼容历史数据：如果存在旧字段 autoApprove（布尔），转为 isUseApplyAutoAudit（0/1）
        if (typeof (data as any).isUseApplyAutoAudit === 'undefined' && typeof (data as any).autoApprove !== 'undefined') {
          (data as any).isUseApplyAutoAudit = (data as any).autoApprove ? 1 : 0
        }
        if (!pileEnable) {
          data.isUseApplyAutoAudit = 0
        }

        // 若后端返回未设置或返回空数组，注入默认分时价，保证渲染侧至少有一项价格
        if (!Array.isArray((data as any).billingPeriodList) || (data as any).billingPeriodList.length === 0) {
          data.billingPeriodList = getDefaultBillingPeriodList();
        }

        if (!data.fee) {
          data.fee = DEFAULT_SERVICE_PRICE;
        }

        setForm(data)
        localStorage.setItem(PILE_SHARING_FORM_KEY, JSON.stringify(data))
        localStorage.setItem(PILE_SHARING_UID_KEY, data.uid)
      } else {
        getQueryShareNewestApplyInfo()
      }
      return
    }
    throw new Error()
  }

  const getQueryShareNewestApplyInfo = async () => {
    const { data, code } = await queryShareNewestApplyInfo({}).finally(() => {
      setLoading(false)
    })
    if ([0, 200].includes(code)) {
      if (data) {
        delete data.applyStatus
        delete data.applyStatusDesc
        delete data.applyRefuseType
        delete data.applyReqId
        data.floor = data.floor + ''
        data.location = {
          lng: data.longitude,
          lat: data.latitude,
        }
        // 解析 findGuide 字段（后端存储的是 JSON 字符串）
        try {
          // 解析 findGuide 字段并兼容历史对象结构，统一为数组 [{textDesc, picList}]
          const parsedFindGuide = JSON.parse(data.findGuide)
          if (Array.isArray(parsedFindGuide)) {
            data.findGuide = parsedFindGuide
          } else if (parsedFindGuide && (parsedFindGuide.textDesc || parsedFindGuide.picList)) {
            data.findGuide = [parsedFindGuide]
          } else {
            data.findGuide = []
          }
        } catch (e) {
          data.findGuide = []
        }
        try {
          data.parkingSpacePicList = JSON.parse(data.parkingSpacePicList) || []
        } catch (e) {
          data.parkingSpacePicList = []
        }
        // 兼容历史数据：如果存在旧字段 autoApprove（布尔），转为 isUseApplyAutoAudit（0/1）
        if (typeof (data as any).isUseApplyAutoAudit === 'undefined' && typeof (data as any).autoApprove !== 'undefined') {
          (data as any).isUseApplyAutoAudit = (data as any).autoApprove ? 1 : 0
        }
        if (!pileEnable) {
          data.isUseApplyAutoAudit = 0
        }
        // 注入默认分时价以兼容后端没有返回该字段或返回空数组的情况
        if (!Array.isArray((data as any).billingPeriodList) || (data as any).billingPeriodList.length === 0) {
          (data as any).billingPeriodList = getDefaultBillingPeriodList();
        }
        if (!data.fee) {
          data.fee = DEFAULT_SERVICE_PRICE;
        }
        setForm(data)
        localStorage.setItem(PILE_SHARING_FORM_KEY, JSON.stringify(data))
        localStorage.setItem(PILE_SHARING_UID_KEY, data.uid)
      } else {
        console.log('no-data');

        getUser()
      }
    }
  }

  //获取用户登录信息
  const getUser = async (phoneNo?) => {
    const { data, code } = await queryCurrentUserBasicInfo().finally(() => {
      setLoading(false)
    })
    if ([0, 200].includes(code)) {
      if (phoneNo) {
        form.phoneNo = data.mobile
        // 合并本地表单并保证 billingPeriodList 存在
        const localForm = getPileSharingFormFromLocalStorage({}) || {}
        const mergedForm = { ...form, ...localForm, phoneNo: data.mobile }
        if (!Array.isArray(mergedForm.billingPeriodList) || mergedForm.billingPeriodList.length === 0) {
          mergedForm.billingPeriodList = getDefaultBillingPeriodList();
        }
        setForm(mergedForm)
        //
        // setForm({ ...form, ...(JSON.parse(localStorage.getItem(PILE_SHARING_FORM_KEY) as any) || {}), phoneNo: data.mobile})
      } else {
        const base = {
          phoneNo: data.mobile,
          uid: data.uid,
          userNickName: data.nickName
        }
        // 保证初始化 also 包含默认分时价
        base['billingPeriodList'] = getDefaultBillingPeriodList();
        setForm(base)
      }
      localStorage.setItem(PILE_SHARING_UID_KEY, data.uid)
    }
  }

  // 埋点
  const getGdp = async () => {
    const { data, code } = await queryCurrentUserBasicInfo()
    localStorage.setItem(PILE_USER_INFO_KEY, JSON.stringify(data))
    trackGdp('P20067', 'B001', {
      step,
      userId: data?.uid,
      userType: UserTypeEnum[data?.type],
      'user_channel': getChannel()
    })
  }

  // // 收费标准失焦校验
  // const feeBlur = () => {
  //   if (!feeReg.test(form.fee)) {
  //     form.fee = ''
  //     setIsTime(true)
  //     setForm({ ...form })
  //     setTimeout(() => {
  //       setIsTime(false)
  //     }, 1000);
  //     Toast.show({ text: '仅可输入0.01~2.99之间的数值', duration: 1000 })
  //   } else {
  //     let u = navigator.userAgent;
  //     let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
  //     if (isAndroid) {
  //       (document.activeElement as any)?.blur();
  //       scheduleRef.current.scrollIntoView(false);
  //     }

  //   }
  // }

  // const onTextareaKeyDown = (event) => {
  //   if (event.keyCode == 13) { //如果按的是enter键 13是enter
  //     event.preventDefault(); //禁止默认事件（默认是换行）
  //     feeBlur()
  //   }
  // }
  const feeSettingClassname = classnames('label', {
    'pile-sharing-apply-label-new-tag': showRedPointOfHasClickedPricesSettinge
  })
  // 监听路由变化，当从子路由返回时更新表单数据
  const updateFormFromStorage = useCallback(async () => {
    try {
      const newData = await getPileSharingFormFromLocalStorage({}, pileNo);
      setForm(prevForm => ({
        ...prevForm,
        ...newData
      }));
    } catch (error) {
      console.error('更新表单数据失败:', error);
    }
  }, [pileNo]);

  // 监听路由变化
  useEffect(() => {
    // 监听浏览器的前进/后退事件
    const handlePopState = () => {
      // 当用户从子路由返回时，更新表单数据
      updateFormFromStorage();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [updateFormFromStorage]);

  // 监听hash变化
  useEffect(() => {
    const handleHashChange = () => {
      // 当hash变化且返回到主路由时，更新表单数据
      updateFormFromStorage();
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [updateFormFromStorage]);

  useAsyncEffect(async () => {
    setTitle();
    if (!localStorage.getItem(PILE_USER_INFO_KEY)) {
      getGdp()
    }
    defineShareInfoInMiniProgram({
      shareTitle: '开通小鹏家充共享，躺着也能赚钱',
      shareIcon: `${CHARGE_CDN}/sharing/mini_share_v2.jpg`,
      shareUrl: `pages/webpage/index?pageUrl=${encodeURIComponent(`${location.origin}/apps/charge-web/pile-sharing-manage.html#/`)}`,
    });

    if (!form.phoneNo) {
      await getUser('phoneNo')
    }
    await getPileNo()
    const formatedData = await getPileSharingFormFromLocalStorage({}, pileNo)
    console.log('initdATA==>', formatedData)
    setForm({
      ...formatedData
    })
    // iOS和微信小程序需要额外处理
    if (platFrom === 'iOS' || isWXApp) {
      window.addEventListener("storage", async () => {
        if (!form.phoneNo) {
          getUser('phoneNo')
        }
        let newData = await getPileSharingFormFromLocalStorage({})
        setForm(newData)
      });
    }
  }, []);

  useEffect(() => {
    console.log('form变化', form)
    localStorage.setItem(PILE_SHARING_FORM_KEY, JSON.stringify(form))
  }, [form]);

  const { data } = useRequest(
    async () => {
      const res = (await getResource("APP_Pile_share_apply")) as any;
      return res;
    },
    { refreshOnWindowFocus: true }
  );

  const appPileShareApplyData = data?.advertItemListMap?.["APP_Pile_share_apply"]
    
  if (loading || !data) {
    return <LoadingPage />
  }

  return (
    <div className='pile-sharing-apply'>
      <Switch>
        <Route exact path={path}>
          <ResourceBanner
            code="APP_Pile_share_apply"
            data={appPileShareApplyData}
            pageId="P20067"
            exposeBid="B010"
            clickBid="B009"
          />
          <div className='pile-sharing-apply-content'>
            <div className='header'>
              <div className='header-top'>
                <span className='left'>什么是共享家充？</span>
                <div className='right' onClick={toMore}>
                  <span className='more'>了解更多</span>
                  <img className='more-icon' src={more} alt="" />
                </div>
              </div>
              <div className='header-content'>
                其他用户在经你同意后可以在合适的时间付费使用你的家充桩，你可以在赚取收益的同时也为他人提供便利，更为保护环境贡献自己的力量。你也可以随时关闭共享，恢复私用状态
              </div>
            </div>
            <div className="schedule" ref={scheduleRef}>
              <div className="steps">
                <img src={step === 1 ? step1 : step1Select} alt="" className="stepsIcon"></img>
                <p className={`liner ${step > 1 ? 'liner2' : ''}`}></p>
                {/* <div className={`pre-step ${step === 2 ? '' : 'not-pre-step'}`} onClick={preStep}>上一步</div> */}
                <img src={step === 1 ? step2 : step2Select} alt="" className="stepsIcon"></img>
              </div>
              <div className="stepsTitle">
                <div className="schedule-text">基本信息</div>
                <div className="schedule-text">完善信息</div>
              </div>
            </div>
            <div className="form">
              {/* 第一步 */}
              {
                step === 1 && <div>
                  <div className='form-item-box'>
                    <div className="inputItem">
                      <div className="label">站点名称</div>
                      <div className='value'>
                        <input
                          placeholder="请输入"
                          maxLength={10}
                          className='value-input'
                          onChange={e => {
                            if (e && e.target) {
                              form.userNickName = e.target.value
                              setForm({ ...form });
                            }
                          }}
                          value={form.userNickName}
                        />
                      </div>
                    </div>
                    <div className='inputItem-mes'>对外会显示为“{form.userNickName}的共享家充”</div>
                  </div>
                  <div className='form-item-box'>
                    <div className="inputItem" style={{ marginBottom: '8px', height: 'auto' }}>
                      <div className="label">详细地址</div>
                      <div className="value" onClick={toMap}>
                        <div className={`value-input ${form.address ? '' : 'default'} formAddress`}>
                          {form.address ? form.address : '请选择所在停车场'}
                        </div>
                        <img src={more} alt="" className="more"></img>
                      </div>
                    </div>
                    <div className='inputItem-mes'>开启共享后该信息会公开展示</div>
                  </div>
                  <div className='form-item-box' onClick={floorSelect}>
                    <div className="inputItem">
                      <div className="label" >车位楼层</div>
                      <div className="value">
                        <div className={` value-input ${form.floor ? '' : 'default'}`}>
                          {form.floor ? floorData.value.find(v => v.value === form.floor)?.label : '请选择'}
                        </div>
                        <img src={more} alt="" className="more"></img>
                      </div>
                    </div>
                    <div className='inputItem-mes'>开启共享后该信息会公开展示</div>
                  </div>
                  <div className='form-item-box'>
                    <div className="inputItem">
                      <div className="label">车位号</div>
                      <div className="value">
                        <input
                          placeholder="请输入(若无则填大致方位)"
                          maxLength={15}
                          className='value-input'
                          onChange={e => {
                            if (e && e.target) {
                              form.parkingSpaceNo = e.target.value
                              setForm({ ...form });
                            }
                          }}
                          value={form.parkingSpaceNo}
                        />
                      </div>

                    </div>
                    <div className='inputItem-mes'>开启共享后该信息会公开展示</div>
                  </div>
                  <div className='form-item-box'>
                    <div className='inputItem'>
                      <div className={feeSettingClassname}>
                        收费标准
                      </div>
                      <div className="value">
                        <div onClick={toSetPeriodPrices} className={`value-input`}>
                          <PriceItem billingPeriodList={form.billingPeriodList || []} fee={form.fee} />
                        </div>
                        <img src={more} alt="" className="more"></img>
                      </div>
                    </div>
                    <div className='inputItem-mes'>
                      不同时段可设置不同的收费价格&nbsp;
                      {
                        !isPeriodPriceMeet
                        &&
                        <ExclamationCircleOutline
                          onClick={
                            () => antdToast.show({
                              content: '您当前桩版本较低，暂不支持按不同时段设置不同价格，我们将在近期为您提供升级服务，请保持桩上电状态',
                              duration: 1500
                            })
                          } />
                      }
                    </div>
                  </div>
                  <div className='form-item-box'>
                    <div className="inputItem">
                      <div className="label">手机号</div>
                      <div className='value'>
                        <input
                          placeholder="请输入"
                          disabled
                          className='value-input value-input-phone'
                          value={form.phoneNo?.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2")}
                        />
                      </div>
                    </div>
                    <div className='inputItem-mes'>当前手机号不支持修改，仅会向你授权通过的用户展示</div>
                  </div>
                </div>
              }
              {/* 第二步 */}
              {
                step > 1 &&
                <>
                  <div className='form-item-box'>
                    <div className='inputItem'>
                      <div className="label not-required">找桩指引</div>
                      <div className="value">
                        <div onClick={toFindGuide} className={`value-input ${form.parkingSpacePicList?.length > 0 ? '' : 'default'}`}>
                          {form.parkingSpacePicList?.length > 0
                            ? '查看我的指引' : '请输入'}
                        </div>
                        <img src={more} alt="" className="more"></img>
                      </div>
                    </div>
                    <div className='inputItem-mes'>
                      {form.findGuide?.[0]?.textDesc ? form.findGuide[0].textDesc : '添加找桩指引可以有效帮助其他人找到你的充电桩，从而获得更多收益'}
                    </div>
                  </div>
                  {/* <div className='form-item-box'>
                <div className="inputItem">
                  <div className="label not-required">微信号</div>
                  <div className='value'>
                    <input
                      placeholder="请输入"
                      maxLength={20}
                      type='text'
                      inputMode='text'
                      autoCapitalize='off'
                      className='value-input'
                      onChange={e => {
                        if (e && e.target) {
                          form.weChatNo = e.target.value
                          setForm({ ...form });
                        }
                      }}
                      value={form.weChatNo}
                    />
                  </div>
                </div>
                <div className='inputItem-mes'>我们仅会向你授权通过的用户展示</div>
              </div> */}

                  <div className='form-item-box' style={{ marginBottom: '4.8vw' }}>
                    <div className='formItem'>
                      <div className="label">对外说明</div>
                      <textarea
                        maxLength={100}
                        rows={4}
                        placeholder="说明停车场是否允许外部车辆进入，需要收取的停车费用等信息，减少线下沟通成本"
                        onChange={e => {
                          form.illustrate = e.target.value
                          setForm({ ...form });
                        }}
                        value={form.illustrate}
                      />
                    </div>
                  </div>
                  <div className='form-item-box'>
                    <div className='inputItem'>
                      <div className="label not-required" style={{ width: 'auto' }}>申请免审核</div>
                      <div className="value">
                        <XPSwitch
                          checked={(form.isUseApplyAutoAudit ? form.isUseApplyAutoAudit : 0) === 1}
                          onChange={checked => {
                            // 将布尔值与 0/1 互转：true -> 1, false -> 0
                            form.isUseApplyAutoAudit = checked ? 1 : 0
                            setForm({ ...form });
                          }}
                          style={{
                            '--height': '6vw',
                            '--width': '10.66667vw',
                          }}
                        />
                      </div>
                    </div>
                    <div className='inputItem-mes'>开启免审核后他人申请使用你的家充桩将自动授权通过</div>
                  </div>
                </>
              }
            </div>

            {/* {step === 2 && <div className='footer-des'>*部分字段默认值取自安装工单，请注意检查</div>} */}
            <div className='footer-step2' onClick={protocolCheck}>
              <img className='check-img' src={isCheck ? checkedRadio : checkRadio} alt="" />
              <div className="protocol">我已阅读并同意 <span onClick={e => openProtocol(e)} className='read'>《小鹏家用充电桩共享协议》</span></div>
            </div>
            {/* {step === 2 && <div className='footer-des'>*提交审核期间请确保桩处于 <span className='status'>通电状态</span> ，否则无法开通</div>} */}
            <div className='footer'>
              {step === 1 && <div onClick={nextStep} className={'pre-view-step pile-sharing-apply-btn'} >完善信息</div>}
              {step === 1 && <div onClick={submit} className={'next-step pile-sharing-apply-btn'} >直接提交</div>}
              {step !== 1 && versionMark > -1 && <div className='pre-view-step pile-sharing-apply-btn' onClick={preStep}>上一步</div>}
              {step !== 1 && <div className="not-next-step pile-sharing-apply-btn" onClick={submit}>提交申请</div>}
            </div>
          </div>

          {showPicker && (
            <Picker
              title="车位楼层"
              onCancel={cancelDateRange}
              onConfirm={confirmDateRange}
              onChange={() => { }}
              value={pickerValue}
              selectData={floorData}
              itemHeight={80}
            ></Picker>
          )}

          {/* {
            modal ? (
              <PopupBottomModal
                title='家用充电桩共享协议'
                visible
                pageClassName='pile-sharing-apply'
                contentClassName='pile-sharing-modal'
                onClose={protocolClose}
              >
                <div className='charging-protocol-content'>
                  <img style={{ width: '100%' }} src={`${CHARGE_CDN}/sharing/agreement_owner.jpg`} alt='' />
                </div>
                <div onClick={pileSharingAgree} className='charging-protocol-btn pile-sharing-apply-btn'>我已知晓相关条款</div>
              </PopupBottomModal>
            ) : null
          } */}

          {/* 取消申请弹窗 */}
          <OrdinaryModel
            visible={showPopupModel}
            title='用户协议'
            text={
              <span className="protocol">
                提交即同意<span onClick={openProtocol} className='read'>《小鹏家用充电桩共享协议》</span>
              </span>
            }
            cancelText="取消"
            onCancel={cancelCbk}
            confirmText="同意并提交"
            onConfirm={confirmCbk}
          />
        </Route>
        {/* 子路由 */}
        {children}
      </Switch>
    </div>
  )
}
export default PrivateStakeApply